/* Stienhardt - diamond PDP trust row (Style 1) BELOW Diamond Specifications (2026-06-27)
   Bullets: Free Shipping / 30-Day Returns / Lifetime Upgrade. Revert = remove
   file + script + Fix #1s CSS. */
(function () {
  'use strict';
  var ship='<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#0A1D2E" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7 h11 v8 h-11 z"/><path d="M15 10 h4 l2 3 v2 h-6 z"/><circle cx="7" cy="17" r="1.6"/><circle cx="17" cy="17" r="1.6"/></svg>';
  var ret='<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#0A1D2E" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12 a7 7 0 1 1 2.2 5.1"/><path d="M5 7 v5 h5"/></svg>';
  var up='<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#0A1D2E" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M12 10 V3 M9 5.5 L12 2.5 L15 5.5"/><path d="M6.5 14 L12 11 L17.5 14 L12 21.5 Z"/><path d="M6.5 14 H17.5 M9.6 14 L12 21.5 M14.4 14 L12 21.5"/></svg>';
  var HTML='<div class="sp-dtrust">'
    +'<div class="sp-dtrust__c">'+ship+'<div class="sp-dtrust__t">Free<br>Shipping</div></div>'
    +'<div class="sp-dtrust__c">'+ret+'<div class="sp-dtrust__t">30-Day<br>Returns</div></div>'
    +'<div class="sp-dtrust__c">'+up+'<div class="sp-dtrust__t">Lifetime<br>Upgrade</div></div>'
    +'</div>';
  function inject() {
    if (document.querySelector('.sp-dtrust')) return true;
    var anchor = document.querySelector('.diamond-product-template .product_description--accordion');
    if (!anchor) return false;
    var w = document.createElement('div'); w.className = 'sp-dtrust-wrap'; w.innerHTML = HTML;
    anchor.parentNode.insertBefore(w, anchor);
    return true;
  }
  var n = 0, iv = setInterval(function () { n++; if (inject() || n > 60) clearInterval(iv); }, 250);
  var mp = document.getElementById('mainproduct'); if (mp) new MutationObserver(inject).observe(mp, { childList: true, subtree: true });
})();
